import {BifrostBackendApi, BifrostBackendNestApi} from "../gateways/BifrostBackendApi.js";
import appConfig from "../appconfig";

const tenantConfig = appConfig.tenantConfig;

const createHeader = function({ authToken }) {
	const headers = {};

	if (authToken) {
		headers.Authorization = authToken;
	}

	return headers;
};

const getShopsApi = (useNewShopsData = false) => {
	return useNewShopsData ? BifrostBackendNestApi : BifrostBackendApi;
};

const ShopsProvider = {
	findAllByChannel(
		authToken,
		onlyActive = true,
		useNewShopsData = false,
		showSecretRestaurants = undefined
	) {
		const queryData = {
			tenantId: tenantConfig.tenantId,
			onlyActive,
			channel: appConfig.channelAlias(),
			timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			showSecretRestaurants
		};
		const url = useNewShopsData ? "/intusr/shops" : "/shops";
		return getShopsApi(useNewShopsData).get(url, {
			headers: {
				...createHeader({ authToken }),
				["X-TenantId"]: tenantConfig.tenantId
			},
			params: queryData
		});
	},

	findAll(
		authToken,
		onlyActive = true,
		useNewShopsData = false,
		showSecretRestaurants = undefined
	) {
		const queryData = {
			tenantId: tenantConfig.tenantId,
			onlyActive,
			timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			showSecretRestaurants
		};
		const url = useNewShopsData ? "/intusr/shops" : "/shops";
		return getShopsApi(useNewShopsData).get(url, {
			headers: {
				...createHeader({ authToken }),
				["X-TenantId"]: tenantConfig.tenantId
			},
			params: queryData
		});
	},

	findOne(
		id, 
		{ 
			authToken,
			useNewShopsData = false
		}
	) {
		const queryData = {
			tenantId: tenantConfig.tenantId
		};

		const url = useNewShopsData ? "/intusr/shops" : "/shops";

		return getShopsApi(useNewShopsData).get(`${url}/${id}`, {
			headers: createHeader({ authToken }),
			params: queryData
		});
	},

	update(id, data, { authToken, jwtToken }) {
		const queryData = {
			tenantId: tenantConfig.tenantId,
			shopId: id
		};
		const token = authToken !== undefined ? authToken : jwtToken;

		return BifrostBackendApi.put(`/shops/${id}`, data, {
			headers: createHeader({authToken: token}),
			params: queryData
		});
	},

	updateCurrentShopApiData(jwtToken) {
		return BifrostBackendApi.get(`/shop-admin/updateFromApi`, {
			params: {
				tenantId: tenantConfig.tenantId
			},
			headers: createHeader({
				authToken: jwtToken
			})
		});
	},

	async getLoggedWithApiData(jwtToken) {
		const response = await BifrostBackendApi.get(`/shop-admin/loggedWithApiData`, {
			headers: createHeader({
				authToken: jwtToken
			})
		});

		return response.data;
	},

	async insertShop(data, jwtToken) {
		const response = await BifrostBackendApi.post("/shops/", data, {
			headers: createHeader({
				authToken: jwtToken
			})
		});
		return response.data;
	}
};

export default Object.freeze(ShopsProvider);
